import CryptoJS from "crypto-js";

let secretKey = "dataEncrypt01001";
export function encrypt(text) {
    // secretKey = await modifySecretKey(secretKey);
    const keyutf = CryptoJS.enc.Utf8.parse(secretKey);
    const iv = CryptoJS.enc.Utf8.parse("678025308de70905");
    const encrypted = CryptoJS.AES.encrypt(text, keyutf, {
        iv: iv,
        padding: CryptoJS.pad.Pkcs7,
        mode: CryptoJS.mode.CBC,
    }).toString();

    return encrypted;
}
/** Function to Decrypt the data */
export function decrypt(text) {
    if (!text) {
        return "";
    }
    try {
        const keyUtf = CryptoJS.enc.Utf8.parse(secretKey);
        const iv = CryptoJS.enc.Utf8.parse("678025308de70905");
        if (text) {
            const decrypted = CryptoJS.AES.decrypt(text, keyUtf, {
                iv: iv,
                padding: CryptoJS.pad.Pkcs7,
                mode: CryptoJS.mode.CBC,
            });
            const decryptedText = decrypted.toString(CryptoJS.enc.Utf8);
            return decryptedText;
        }
    } catch (error) {
        console.error("Error decrypting text:", error);
        throw error;
    }
}

export let encryptByText = async (text) => {
    let a = text.split("");
    let ae = await Promise.all(
        a.map(async (v) => {
            let data = await encrypt(v);
            return data;
        })
    );
    return ae.join(""); // Join with space or any delimiter
};

export let decryptByText = (encryptedText) => {
    try {
        let encryptedComponents = encryptedText.split("=="); // Split by the same delimiter used in encryption
        let decryptedComponents = encryptedComponents.map((comp) => {
            let data = decrypt(comp + "==");
            return data;
        });
        return decryptedComponents.join("");
    } catch (error) {
        console.log("error decryptByText ", encryptedText);
        return "";
    }
    // Split the concatenated encrypted text back into its components
};
